import React from 'react';
import './TokenPopup.css';
import { Link } from 'react-router-dom';

const TokenPopup = ({ tokenCount, updateTokenCount, closePopup }) => {
  const pricePerCredit = 10; // update as needed

  return (
    <div className="tp-overlay">
      <div className="tp-modal">

        {/* HEADER */}
        <div className="tp-header">
          <h2 className="tp-title">Buy D-credits</h2>
          <p className="tp-sub">Each credit lets you post one node.</p>
        </div>

        {/* COUNTER */}
        <div className="tp-counter">
          <button
            className="tp-counter-btn"
            onClick={() => updateTokenCount(tokenCount > 1 ? tokenCount - 1 : tokenCount)}
            disabled={tokenCount === 1}
          >
            −
          </button>
          <span className="tp-count">{tokenCount}</span>
          <button
            className="tp-counter-btn"
            onClick={() => updateTokenCount(tokenCount + 1)}
          >
            +
          </button>
        </div>
        {/* ACTIONS */}
        <div className="tp-actions">
          <button className="tp-close-btn" onClick={closePopup}>
            Cancel
          </button>
          <Link to={`/checkout?tokens=${tokenCount}`} className="tp-next-btn">
            Proceed
          </Link>
        </div>

      </div>
    </div>
  );
};

export default TokenPopup;
